import { render, staticRenderFns } from "./Zis.vue?vue&type=template&id=144845e8"
import script from "./Zis.vue?vue&type=script&lang=js"
export * from "./Zis.vue?vue&type=script&lang=js"
import style0 from "./Zis.vue?vue&type=style&index=0&id=144845e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports